import $ from 'jquery';
import { getStorage } from '../../../home24/helpers/storage-factory';
import { getCurrentDataLayer } from '../../../home24-shared/tracking/common/helper';
import BaseView from '../../core/baseView';
import * as registry from '../../../home24/core/registry';

/**
 * new list view: tracking for filters
 */
export default BaseView.extend({

    events: {
        submit: 'onFormSubmit'
    },

    // object that is pushed to dataLayer
    data: {},

    // name of cookie where data will be stored
    cookieName: 'GtmOnFilterNavigation',

    // flag to prevent double push as form is sent twice
    wasPushedToDataLayer: false,

    initialize: function () {
        this.readCookie();
        this.setDefaultData();
    },

    setDefaultData: function () {
        this.data = {
            current_page: [location.protocol, '//', location.host, location.pathname].join(''),
            current_page_type: getCurrentDataLayer().pageType,
            current_page_level: (registry.get('categoryLevel')) ? registry.get('categoryLevel') : 0,

            // is set after page reload
            click_destination_level: '',
            click_position: 'FilterTop',
            event: 'filter_click',
            filters: []
        };
    },

    setCookie: function () {
        getStorage().set(this.cookieName, JSON.stringify(this.data));
    },

    readCookie: function () {
        var cookieValue = getStorage().get(this.cookieName);

        if (cookieValue) {
            this.pushData($.parseJSON(cookieValue));
        }
    },

    pushData: function (data) {
        var clickDestination;

        clickDestination = registry.get('categoryLevel');

        if (data.click_destination_level === '' && typeof clickDestination !== 'undefined') {
            data.click_destination_level = clickDestination;
        }

        window.dataLayer.push(data);
        this.clearCookie();
    },

    clearCookie: function () {
        getStorage().unset(this.cookieName);
    },

    onFormSubmit: function () {

        if (!this.wasPushedToDataLayer) {
            this.data.filters = this.getActiveFilters();
            this.setCookie();
            this.wasPushedToDataLayer = true;
        }
    },

    getActiveFilters: function () {

        var filters = [];
        var singleFilterData = {};
        var that = this;

        this.$el.find('.js-filter-range').each(function (index, element) {
            singleFilterData = that.getRangeFilterData(element);

            if (singleFilterData) {
                filters.push(singleFilterData);
            }
        });

        this.$el.find('.js-filter-list-with-buttons').each(function (index, element) {
            singleFilterData = that.getCheckboxFilterData(element);

            if (singleFilterData) {
                filters.push(singleFilterData);
            }
        });

        return filters;
    },

    // for range filters, check if anyone is enabled, then prepare tracking data
    getRangeFilterData: function (element) {

        var $filter = $(element);
        var $minInput = $filter.find('.js-filter-range-min-input');
        var $maxInput = $filter.find('.js-filter-range-max-input');
        var name;
        var enabled = true;
        var result = false;

        // check if both are not disabled
        if ($minInput.prop('disabled') && $maxInput.prop('disabled')) {
            enabled = false;
        }

        if (enabled) {

            // prepare name
            name = $filter.find('.js-filter-range-min-input').attr('name');
            name = name.substring(0, name.length - 4);

            result = {
                position: $filter.data('position'),
                name: name,
                value: $minInput.val() + '-' + $maxInput.val()
            };
        }

        return result;
    },

    getCheckboxFilterData: function (element) {

        var $filter = $(element);
        var value;
        var result = false;

        value = $filter.find('.js-filter-list-hidden').val();

        if (value !== '') {
            result = {
                position: $filter.data('position'),
                name: $filter.find('.js-filter-list-hidden').attr('name'),
                value: value
            };
        }

        return result;
    }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/tracking/catalog/filterEvents.js
 **/